export const isTcoatQuotationItem = (item = {}, paintSkuSet = null, upsellingSkuSet = null) => {
  const sku = String(item.product_sku || item.item_code || '').trim();
  const skuKey = sku.toUpperCase();
  if (skuKey && upsellingSkuSet && upsellingSkuSet.has(skuKey)) return false;
  if (skuKey && paintSkuSet && paintSkuSet.has(skuKey)) return true;
  const name = String(item.item_name || item.product_name || '');
  if (paintSkuSet || upsellingSkuSet) return false;
  return /t-?coat/i.test(name);
};

export const isUpsellingQuotationItem = (item = {}, paintSkuSet = null, upsellingSkuSet = null) => {
  const sku = String(item.product_sku || item.item_code || '').trim();
  const skuKey = sku.toUpperCase();
  if (skuKey && upsellingSkuSet && upsellingSkuSet.has(skuKey)) return true;
  if (skuKey && paintSkuSet && paintSkuSet.has(skuKey)) return false;
  if (paintSkuSet || upsellingSkuSet) return false;
  return !isTcoatQuotationItem(item, paintSkuSet, upsellingSkuSet);
};

export const partitionQuotationLineItems = (lineItems = [], paintSkuSet = null, upsellingSkuSet = null) => {
  const production = [];
  const upselling = [];
  (lineItems || []).forEach((item) => {
    if (isTcoatQuotationItem(item, paintSkuSet, upsellingSkuSet)) {
      production.push(item);
    } else if (isUpsellingQuotationItem(item, paintSkuSet, upsellingSkuSet)) {
      upselling.push(item);
    }
  });
  return { production, upselling };
};

export const buildDefaultLineSelections = (items = []) => {
  const map = {};
  (items || []).forEach((item) => {
    const id = Number(item.id);
    if (!id) return;
    map[id] = {
      enabled: true,
      quantity: String(item.quantity ?? ''),
    };
  });
  return map;
};

/** Same shape as defaults, but with every line unchecked (omit request). */
export const buildClearedLineSelections = (items = []) => {
  const map = {};
  (items || []).forEach((item) => {
    const id = Number(item.id);
    if (!id) return;
    map[id] = {
      enabled: false,
      quantity: String(item.quantity ?? ''),
    };
  });
  return map;
};
